import './SkillComponent.scss';

import React from 'react';
import PropTypes from 'prop-types';

function SkillComponent({ skill, name }) {
  return (
    <div className='skill'>
      <div className='skill--icon'>{skill}</div>
      <div className='skill--name'>{name}</div>
    </div>
  );
}

SkillComponent.propTypes = {
  skill: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
};

export default SkillComponent;
